// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2GTaF","label":"LabeledBox_label__26Yju"};